/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './support.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../app/admin/help/support/support.component';
const styles_SupportComponent:any[] = [i0.styles];
export const RenderType_SupportComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SupportComponent,data:{}});
export function View_SupportComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'p',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n  support works!\n'])),(_l()(),i1.ɵted(-1,(null as any),
      ['\n']))],(null as any),(null as any));
}
export function View_SupportComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-support',
      ([] as any[]),(null as any),(null as any),(null as any),View_SupportComponent_0,
      RenderType_SupportComponent)),i1.ɵdid(1,114688,(null as any),0,i2.SupportComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const SupportComponentNgFactory:i1.ComponentFactory<i2.SupportComponent> = i1.ɵccf('app-support',
    i2.SupportComponent,View_SupportComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9hZG1pbi9oZWxwL3N1cHBvcnQvc3VwcG9ydC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL3d3dy9odG1sL015RGVzaWduVjMvaHRtbC9zcmMvYXBwL2FkbWluL2hlbHAvc3VwcG9ydC9zdXBwb3J0LmNvbXBvbmVudC50cyIsIm5nOi8vL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9hZG1pbi9oZWxwL3N1cHBvcnQvc3VwcG9ydC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9hZG1pbi9oZWxwL3N1cHBvcnQvc3VwcG9ydC5jb21wb25lbnQudHMuU3VwcG9ydENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxwPlxuICBzdXBwb3J0IHdvcmtzIVxuPC9wPlxuIiwiPGFwcC1zdXBwb3J0PjwvYXBwLXN1cHBvcnQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUEsd0VBQUc7YUFBQSw2Q0FFQztNQUFBOzs7b0JDRko7TUFBQTtpQ0FBQSxVQUFBO01BQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/admin/help/support/support.component.ngfactory.ts